export const SIDENAV_CONFIG = {
    COLLAPSED: 68, // Width of the narrow rail shown while collapsed.
    COMPACT: 1200, // Below this viewport width the sidenav collapses to a narrow rail and expands on hover/focus. At or above it the sidenav is always expanded.
    EXPANDED: 240,
    MOBILE: 576 // Below this viewport width (Bootstrap xs) the rail is hidden entirely and the sidenav becomes an off-canvas drawer toggled by the TopNav hamburger.
} as const;